import $ from 'jquery';
import { setDefaultQrCodeValues } from '~src/sidebar/qr';

export const handleQrTypeSelection = (e) => {
  $('.qr-selection').removeClass('qr-active');

  const category = e.target.id;

  $(`.btn-${category}`).addClass('qr-active');
  const name = $(`.btn-${category}`).text();

  setDefaultQrCodeValues(name);

  category === 'qr-website'
    ? $('#qr-form-user-input').attr(
        'placeholder',
        "Inserire l'indirizzo del sito web"
      )
    : $('#qr-form-user-input').attr(
        'placeholder',
        'Num. di telefono o cell, esempio: 0694502976'
      );
};
